import { Address } from '@alluradirect/react';
import Grid from 'components/core/Grid';
import { AddressAutocompleteProps } from 'components/formik/core/FormikAddressAutocomplete/AddressAutocomplete';
import { FormikAddressAutocomplete } from 'components/formik/core/FormikAddressAutocomplete/FormikAddressAutocomplete';
import AddressFormikForm from 'components/views/AddressFormikForm/AddressFormikForm';
import { useFormikContext } from 'formik';
import { useMemo } from 'react';

interface FormikAddressProps {
  hideAddressFieldsIfNoAddress?: boolean;
  isDisabled?: boolean;
}

type Props = FormikAddressProps & Omit<AddressAutocompleteProps, 'initialAddress'>;

export const FormikAddress = ({ formikPrefix, locationDetails, hideAddressFieldsIfNoAddress = true, isDisabled = false }: Props) => {
  const { values } = useFormikContext<any>();

  const formikAddress = useMemo(() => {
    const prefixes = `${formikPrefix}ADDRESS`.split('.');
    let val: any = values;
    prefixes.forEach(prefix => {
      val = val[prefix] ?? '';
    });
    return val;
  }, [formikPrefix, values]);

  return (
    <>
      <Grid item xs={12}>
        <FormikAddressAutocomplete
          formikPrefix={formikPrefix}
          locationDetails={locationDetails}
          initialAddress={hasFullAddressForAutocompleteDisplay(formikAddress) ? formikAddress : undefined}
          isDisabled={isDisabled}
        />
      </Grid>
      <AddressFormikForm
        formikAddressValue={formikAddress}
        formikPrefix={formikPrefix}
        locationData={locationDetails}
        shouldHideIfNoAddress={hideAddressFieldsIfNoAddress}
        isDisabled={isDisabled}
      />
    </>
  );
};

function hasFullAddressForAutocompleteDisplay(address: Address | undefined) {
  if (!address) return false;

  if (!address.CITY) return false;
  if (!address.REGION) return false;
  if (!address.STREET_NAME || !address.STREET_NUMBER) return false;
  if (!address.COUNTRY) return false;

  return true;
}
